import { useEffect, useState } from 'react';
import { getOrderProducts } from '../api/orderApi';

export function useOrderProducts({
                                     enabled, customerId, branchId, search, page, pageSize = 10,
                                     webCategoryId, webSubCategoryId
                                 }) {
    const [state, setState] = useState({
        products: [],
        customerName: '',
        hasMore: true,
        error: null,
    });

    useEffect(() => {
        if (!enabled) return;
        const controller = new AbortController();

        (async () => {
            try {
                const data = await getOrderProducts({
                    customerId,
                    branchId,
                    search,
                    page,
                    size: pageSize,
                    webCategoryId,
                    webSubCategoryId,
                    signal: controller.signal,
                });

                if (!data || !Array.isArray(data.products)) {
                    setState({ products: [], customerName: '', hasMore: false, error: null });
                    return;
                }

                setState({
                    products: data.products,
                    customerName: data.customerName || '',
                    hasMore: data.products.length === pageSize,
                    error: null,
                });
            } catch (err) {
                if (err.name === 'AbortError') return;
                console.error('Fetch error:', err);
                setState((s) => ({ ...s, hasMore: false, error: err }));
            }
        })();

        return () => controller.abort();
    }, [enabled, customerId, branchId, search, page, pageSize, webCategoryId, webSubCategoryId]);

    return state;
}
